"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_CAN_SPAM_SETTINGS_FAIL = exports.UPDATE_CAN_SPAM_SETTINGS_SUCCESS = exports.UPDATE_CAN_SPAM_SETTINGS_PENDING = exports.CAN_SPAM_SETTINGS_FETCH = exports.SHIFT_FIELD_VALIDATION_ERROR = exports.REMOVE_FIELD_VALIDATION_ERROR = exports.ADD_FIELD_VALIDATION_ERROR = exports.GOOGLE_FONTS_FETCH_COMMON_FONTS = exports.SELECT_GOOGLE_FONT = exports.GOOGLE_FONTS_CLEAR = exports.GOOGLE_FONTS_FETCH_FONTS = exports.GOOGLE_FONTS_FETCH_FONT = exports.VIDEOS_SAVE_VIDEO = exports.VIDEOS_FETCH_VIDEO = exports.TEAMS_UPDATE_TEAMS_DATA = exports.TEAMS_FETCH_TEAMS = exports.SITE_SETTINGS_FETCH = exports.FETCH_SELECTED_ICONS = exports.SAVE_ICON = exports.FETCH_ICONS = exports.FETCH_ICON = exports.CLEAR_ICONS = exports.GOTOWEBINAR_FETCH_ELIGIBLE_FORMS = exports.GOTOWEBINAR_FETCH_SETTINGS = exports.GOTOWEBINAR_FETCH_FUTURE_WEBINARS = exports.SURVEYS_UPDATE_SURVEY_STATE = exports.SURVEYS_SAVE_SURVEY_CACHE = exports.SURVEYS_CLEAR_CACHE = exports.SURVEYS_FETCH = exports.SURVEYS_FETCH_SURVEY = exports.SALESFORCE_FETCH_INTEGRATION_STATUS = exports.SALESFORCE_FETCH_CAMPAIGNS = exports.SALESFORCE_FETCH_CAMPAIGN = exports.MEETINGS_FETCH_MEETINGS = exports.MEETINGS_FETCH_MEETING = exports.CTAS_CLEAR_CACHE = exports.CTAS_SAVE_CTA_CACHE = exports.CTAS_FETCH_CTAS = exports.CTAS_FETCH_CTA = exports.MENUS_CLEAR_CACHE = exports.MENUS_SAVE_MENU_CACHE = exports.MENUS_FETCH_MENUS = exports.MENUS_FETCH_MENU = exports.MENUS_CREATE_MENU = exports.EMAILS_CREATE_EMAIL = exports.EMAILS_CLEAR_CACHE = exports.EMAILS_SAVE_EMAIL_CACHE = exports.EMAILS_FETCH_EMAILS = exports.EMAILS_FETCH_EMAIL = exports.PAGES_CLEAR_CACHE = exports.PAGES_SAVE_PAGE_CACHE = exports.PAGES_FETCH_PAGES = exports.PAGES_FETCH_PAGE = exports.HUBDB_CLEAR_CACHE = exports.HUBDB_SAVE_TABLE_CACHE = exports.HUBDB_FETCH_TABLES = exports.HUBDB_FETCH_TABLE = exports.USERS_UPDATE_USERS_FOR_TEAMS = exports.USERS_FETCH_USERS_FOR_TEAMS = exports.USERS_FETCH_USERS = exports.TAGS_CLEAR_CACHE = exports.TAGS_SAVE_TAG_CACHE = exports.TAGS_FETCH_TAGS = exports.TAGS_FETCH_TAG_BY_SLUG = exports.TAGS_FETCH_TAG = exports.WORKFLOWS_CREATE_WORKFLOW = exports.WORKFLOWS_FETCH_WORKFLOWS = exports.WORKFLOWS_FETCH_WORKFLOW = exports.FORMS_SAVE_FORM_CACHE = exports.FORMS_CLEAR_CACHE = exports.FORMS_CREATE = exports.FORMS_FETCH = exports.FORMS_FETCH_FORM = exports.BLOGS_CLEAR_CACHE = exports.BLOGS_SAVE_BLOG_CACHE = exports.BLOGS_FETCH_BLOGS = exports.BLOGS_FETCH_BLOG = void 0;
var BLOGS_FETCH_BLOG = 'BLOGS_FETCH_BLOG';
exports.BLOGS_FETCH_BLOG = BLOGS_FETCH_BLOG;
var BLOGS_FETCH_BLOGS = 'BLOGS_FETCH_BLOGS';
exports.BLOGS_FETCH_BLOGS = BLOGS_FETCH_BLOGS;
var BLOGS_SAVE_BLOG_CACHE = 'BLOGS_SAVE_BLOG_CACHE';
exports.BLOGS_SAVE_BLOG_CACHE = BLOGS_SAVE_BLOG_CACHE;
var BLOGS_CLEAR_CACHE = 'BLOGS_CLEAR_CACHE';
exports.BLOGS_CLEAR_CACHE = BLOGS_CLEAR_CACHE;
var FORMS_FETCH_FORM = 'FORMS_FETCH_FORM';
exports.FORMS_FETCH_FORM = FORMS_FETCH_FORM;
var FORMS_FETCH = 'FORMS_FETCH';
exports.FORMS_FETCH = FORMS_FETCH;
var FORMS_CREATE = 'FORMS_CREATE';
exports.FORMS_CREATE = FORMS_CREATE;
var FORMS_CLEAR_CACHE = 'FORMS_CLEAR_CACHE';
exports.FORMS_CLEAR_CACHE = FORMS_CLEAR_CACHE;
var FORMS_SAVE_FORM_CACHE = 'FORMS_SAVE_FORM_CACHE';
exports.FORMS_SAVE_FORM_CACHE = FORMS_SAVE_FORM_CACHE;
var WORKFLOWS_FETCH_WORKFLOW = 'WORKFLOWS_FETCH_WORKFLOW';
exports.WORKFLOWS_FETCH_WORKFLOW = WORKFLOWS_FETCH_WORKFLOW;
var WORKFLOWS_FETCH_WORKFLOWS = 'WORKFLOWS_FETCH_WORKFLOWS';
exports.WORKFLOWS_FETCH_WORKFLOWS = WORKFLOWS_FETCH_WORKFLOWS;
var WORKFLOWS_CREATE_WORKFLOW = 'WORKFLOWS_CREATE_WORKFLOW';
exports.WORKFLOWS_CREATE_WORKFLOW = WORKFLOWS_CREATE_WORKFLOW;
var TAGS_FETCH_TAG = 'TAGS_FETCH_TAG';
exports.TAGS_FETCH_TAG = TAGS_FETCH_TAG;
var TAGS_FETCH_TAG_BY_SLUG = 'TAGS_FETCH_TAG_BY_SLUG';
exports.TAGS_FETCH_TAG_BY_SLUG = TAGS_FETCH_TAG_BY_SLUG;
var TAGS_FETCH_TAGS = 'TAGS_FETCH_TAGS';
exports.TAGS_FETCH_TAGS = TAGS_FETCH_TAGS;
var TAGS_SAVE_TAG_CACHE = 'TAGS_SAVE_TAG_CACHE';
exports.TAGS_SAVE_TAG_CACHE = TAGS_SAVE_TAG_CACHE;
var TAGS_CLEAR_CACHE = 'TAGS_CLEAR_CACHE';
exports.TAGS_CLEAR_CACHE = TAGS_CLEAR_CACHE;
var USERS_FETCH_USERS = 'USERS_FETCH_USERS';
exports.USERS_FETCH_USERS = USERS_FETCH_USERS;
var USERS_FETCH_USERS_FOR_TEAMS = 'USERS_FETCH_USERS_FOR_TEAMS';
exports.USERS_FETCH_USERS_FOR_TEAMS = USERS_FETCH_USERS_FOR_TEAMS;
var USERS_UPDATE_USERS_FOR_TEAMS = 'USERS_UPDATE_USERS_FOR_TEAMS';
exports.USERS_UPDATE_USERS_FOR_TEAMS = USERS_UPDATE_USERS_FOR_TEAMS;
var HUBDB_FETCH_TABLE = 'HUBDB_FETCH_TABLE';
exports.HUBDB_FETCH_TABLE = HUBDB_FETCH_TABLE;
var HUBDB_FETCH_TABLES = 'HUBDB_FETCH_TABLES';
exports.HUBDB_FETCH_TABLES = HUBDB_FETCH_TABLES;
var HUBDB_SAVE_TABLE_CACHE = 'HUBDB_SAVE_TABLE_CACHE';
exports.HUBDB_SAVE_TABLE_CACHE = HUBDB_SAVE_TABLE_CACHE;
var HUBDB_CLEAR_CACHE = 'HUBDB_CLEAR_CACHE';
exports.HUBDB_CLEAR_CACHE = HUBDB_CLEAR_CACHE;
var PAGES_FETCH_PAGE = 'PAGES_FETCH_PAGE';
exports.PAGES_FETCH_PAGE = PAGES_FETCH_PAGE;
var PAGES_FETCH_PAGES = 'PAGES_FETCH_PAGES';
exports.PAGES_FETCH_PAGES = PAGES_FETCH_PAGES;
var PAGES_SAVE_PAGE_CACHE = 'PAGES_SAVE_PAGE_CACHE';
exports.PAGES_SAVE_PAGE_CACHE = PAGES_SAVE_PAGE_CACHE;
var PAGES_CLEAR_CACHE = 'PAGES_CLEAR_CACHE';
exports.PAGES_CLEAR_CACHE = PAGES_CLEAR_CACHE;
var EMAILS_FETCH_EMAIL = 'EMAILS_FETCH_EMAIL';
exports.EMAILS_FETCH_EMAIL = EMAILS_FETCH_EMAIL;
var EMAILS_FETCH_EMAILS = 'EMAILS_FETCH_EMAILS';
exports.EMAILS_FETCH_EMAILS = EMAILS_FETCH_EMAILS;
var EMAILS_SAVE_EMAIL_CACHE = 'EMAILS_SAVE_EMAIL_CACHE';
exports.EMAILS_SAVE_EMAIL_CACHE = EMAILS_SAVE_EMAIL_CACHE;
var EMAILS_CLEAR_CACHE = 'EMAILS_CLEAR_CACHE';
exports.EMAILS_CLEAR_CACHE = EMAILS_CLEAR_CACHE;
var EMAILS_CREATE_EMAIL = 'EMAILS_CREATE_EMAIL';
exports.EMAILS_CREATE_EMAIL = EMAILS_CREATE_EMAIL;
var MENUS_CREATE_MENU = 'MENUS_CREATE_MENU';
exports.MENUS_CREATE_MENU = MENUS_CREATE_MENU;
var MENUS_FETCH_MENU = 'MENUS_FETCH_MENU';
exports.MENUS_FETCH_MENU = MENUS_FETCH_MENU;
var MENUS_FETCH_MENUS = 'MENUS_FETCH_MENUS';
exports.MENUS_FETCH_MENUS = MENUS_FETCH_MENUS;
var MENUS_SAVE_MENU_CACHE = 'MENUS_SAVE_MENU_CACHE';
exports.MENUS_SAVE_MENU_CACHE = MENUS_SAVE_MENU_CACHE;
var MENUS_CLEAR_CACHE = 'MENUS_CLEAR_CACHE';
exports.MENUS_CLEAR_CACHE = MENUS_CLEAR_CACHE;
var CTAS_FETCH_CTA = 'CTAS_FETCH_CTA';
exports.CTAS_FETCH_CTA = CTAS_FETCH_CTA;
var CTAS_FETCH_CTAS = 'CTAS_FETCH_CTAS';
exports.CTAS_FETCH_CTAS = CTAS_FETCH_CTAS;
var CTAS_SAVE_CTA_CACHE = 'CTAS_SAVE_CTA_CACHE';
exports.CTAS_SAVE_CTA_CACHE = CTAS_SAVE_CTA_CACHE;
var CTAS_CLEAR_CACHE = 'CTAS_CLEAR_CACHE';
exports.CTAS_CLEAR_CACHE = CTAS_CLEAR_CACHE;
var MEETINGS_FETCH_MEETING = 'MEETINGS_FETCH_MEETING';
exports.MEETINGS_FETCH_MEETING = MEETINGS_FETCH_MEETING;
var MEETINGS_FETCH_MEETINGS = 'MEETINGS_FETCH_MEETINGS';
exports.MEETINGS_FETCH_MEETINGS = MEETINGS_FETCH_MEETINGS;
var SALESFORCE_FETCH_CAMPAIGN = 'SALESFORCE_FETCH_CAMPAIGN';
exports.SALESFORCE_FETCH_CAMPAIGN = SALESFORCE_FETCH_CAMPAIGN;
var SALESFORCE_FETCH_CAMPAIGNS = 'SALESFORCE_FETCH_CAMPAIGNS';
exports.SALESFORCE_FETCH_CAMPAIGNS = SALESFORCE_FETCH_CAMPAIGNS;
var SALESFORCE_FETCH_INTEGRATION_STATUS = 'SALESFORCE_FETCH_INTEGRATION_STATUS';
exports.SALESFORCE_FETCH_INTEGRATION_STATUS = SALESFORCE_FETCH_INTEGRATION_STATUS;
var SURVEYS_FETCH_SURVEY = 'SURVEYS_FETCH_SURVEY';
exports.SURVEYS_FETCH_SURVEY = SURVEYS_FETCH_SURVEY;
var SURVEYS_FETCH = 'SURVEYS_FETCH';
exports.SURVEYS_FETCH = SURVEYS_FETCH;
var SURVEYS_CLEAR_CACHE = 'SURVEYS_CLEAR_CACHE';
exports.SURVEYS_CLEAR_CACHE = SURVEYS_CLEAR_CACHE;
var SURVEYS_SAVE_SURVEY_CACHE = 'SURVEYS_SAVE_SURVEY_CACHE';
exports.SURVEYS_SAVE_SURVEY_CACHE = SURVEYS_SAVE_SURVEY_CACHE;
var SURVEYS_UPDATE_SURVEY_STATE = 'SURVEYS_UPDATE_SURVEY_STATE';
exports.SURVEYS_UPDATE_SURVEY_STATE = SURVEYS_UPDATE_SURVEY_STATE;
var GOTOWEBINAR_FETCH_FUTURE_WEBINARS = 'GOTOWEBINAR_FETCH_FUTURE_WEBINARS';
exports.GOTOWEBINAR_FETCH_FUTURE_WEBINARS = GOTOWEBINAR_FETCH_FUTURE_WEBINARS;
var GOTOWEBINAR_FETCH_SETTINGS = 'GOTOWEBINAR_FETCH_SETTINGS';
exports.GOTOWEBINAR_FETCH_SETTINGS = GOTOWEBINAR_FETCH_SETTINGS;
var GOTOWEBINAR_FETCH_ELIGIBLE_FORMS = 'GOTOWEBINAR_FETCH_ELIGIBLE_FORMS';
exports.GOTOWEBINAR_FETCH_ELIGIBLE_FORMS = GOTOWEBINAR_FETCH_ELIGIBLE_FORMS;
var CLEAR_ICONS = 'CLEAR_ICONS';
exports.CLEAR_ICONS = CLEAR_ICONS;
var FETCH_ICON = 'FETCH_ICON';
exports.FETCH_ICON = FETCH_ICON;
var FETCH_ICONS = 'FETCH_ICONS';
exports.FETCH_ICONS = FETCH_ICONS;
var SAVE_ICON = 'SAVE_ICON';
exports.SAVE_ICON = SAVE_ICON;
var FETCH_SELECTED_ICONS = 'FETCH_SELECTED_ICONS';
exports.FETCH_SELECTED_ICONS = FETCH_SELECTED_ICONS;
var SITE_SETTINGS_FETCH = 'SITE_SETTINGS_FETCH';
exports.SITE_SETTINGS_FETCH = SITE_SETTINGS_FETCH;
var TEAMS_FETCH_TEAMS = 'TEAMS_FETCH_TEAMS';
exports.TEAMS_FETCH_TEAMS = TEAMS_FETCH_TEAMS;
var TEAMS_UPDATE_TEAMS_DATA = 'TEAMS_UPDATE_TEAMS_DATA';
exports.TEAMS_UPDATE_TEAMS_DATA = TEAMS_UPDATE_TEAMS_DATA;
var VIDEOS_FETCH_VIDEO = 'VIDEOS_FETCH_VIDEO';
exports.VIDEOS_FETCH_VIDEO = VIDEOS_FETCH_VIDEO;
var VIDEOS_SAVE_VIDEO = 'VIDEOS_SAVE_VIDEO';
exports.VIDEOS_SAVE_VIDEO = VIDEOS_SAVE_VIDEO;
var GOOGLE_FONTS_FETCH_FONT = 'GOOGLE_FONTS_FETCH_FONT';
exports.GOOGLE_FONTS_FETCH_FONT = GOOGLE_FONTS_FETCH_FONT;
var GOOGLE_FONTS_FETCH_FONTS = 'GOOGLE_FONTS_FETCH_FONTS';
exports.GOOGLE_FONTS_FETCH_FONTS = GOOGLE_FONTS_FETCH_FONTS;
var GOOGLE_FONTS_CLEAR = 'GOOGLE_FONTS_CLEAR';
exports.GOOGLE_FONTS_CLEAR = GOOGLE_FONTS_CLEAR;
var SELECT_GOOGLE_FONT = 'SELECT_GOOGLE_FONT';
exports.SELECT_GOOGLE_FONT = SELECT_GOOGLE_FONT;
var GOOGLE_FONTS_FETCH_COMMON_FONTS = 'GOOGLE_FONTS_FETCH_COMMON_FONTS';
exports.GOOGLE_FONTS_FETCH_COMMON_FONTS = GOOGLE_FONTS_FETCH_COMMON_FONTS;
var ADD_FIELD_VALIDATION_ERROR = 'ADD_FIELD_VALIDATION_ERROR';
exports.ADD_FIELD_VALIDATION_ERROR = ADD_FIELD_VALIDATION_ERROR;
var REMOVE_FIELD_VALIDATION_ERROR = 'REMOVE_FIELD_VALIDATION_ERROR';
exports.REMOVE_FIELD_VALIDATION_ERROR = REMOVE_FIELD_VALIDATION_ERROR;
var SHIFT_FIELD_VALIDATION_ERROR = 'SHIFT_FIELD_VALIDATION_ERROR';
exports.SHIFT_FIELD_VALIDATION_ERROR = SHIFT_FIELD_VALIDATION_ERROR;
var CAN_SPAM_SETTINGS_FETCH = 'CAN_SPAM_SETTINGS_FETCH';
exports.CAN_SPAM_SETTINGS_FETCH = CAN_SPAM_SETTINGS_FETCH;
var UPDATE_CAN_SPAM_SETTINGS_PENDING = 'UPDATE_CAN_SPAM_SETTINGS_PENDING';
exports.UPDATE_CAN_SPAM_SETTINGS_PENDING = UPDATE_CAN_SPAM_SETTINGS_PENDING;
var UPDATE_CAN_SPAM_SETTINGS_SUCCESS = 'UPDATE_CAN_SPAM_SETTINGS_SUCCESS';
exports.UPDATE_CAN_SPAM_SETTINGS_SUCCESS = UPDATE_CAN_SPAM_SETTINGS_SUCCESS;
var UPDATE_CAN_SPAM_SETTINGS_FAIL = 'UPDATE_CAN_SPAM_SETTINGS_FAIL';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

exports.UPDATE_CAN_SPAM_SETTINGS_FAIL = UPDATE_CAN_SPAM_SETTINGS_FAIL;

if (!!module && !!module.exports) {
  module.exports.default = module.exports;
}